import type { ShareCreditNotesRequest } from '@vy/api-definition';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useShareCreditNotes(options?: UseMutationOptions<void, unknown, ShareCreditNotesRequest>) {
  const api = getPrivateApi();

  return useMutation({
    mutationFn: async (shareCreditNotesRequest) => api.shareCreditNotes({ shareCreditNotesRequest }),
    ...options,
  });
}
